import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ContactManager from "../components/ContactDetailsLayer";

const ContactDetailsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Contact Details" />

        {/* DashBoardLayerTwo */}
        <ContactManager />

      </MasterLayout>
    </>
  );
};

export default ContactDetailsPage;
